import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import '../../styling/ClientPortal.css'; // Ensure this file exists and the path is correct
import LeftClientPanel from "../panels/LeftClientPanel"; // Ensure this file exists
import GalleryTab from "../tabs/GalleryTab"; // Ensure this file exists
import EventGalleryTab from "../tabs/EventGallery"; // Ensure this file exists
import InvoiceTab from "../tabs/InvoiceTab"; // Ensure this file exists
import OverviewTab from "../tabs/OverviewTab"; // Ensure this file exists

import PackagesTab from "../tabs/PackagesTab"; // Ensure this file exists



import QuestionnaireTab from "../tabs/QuestionnaireTab"; // Ensure this file exists
import TemplateTab from "../tabs/TemplateTab"; // Ensure this file exists
const ClientPortal = ({ brandingColours, clientData, businessId, initialTabIndex = 0}) => {

     const [selectedIndex, setSelectedIndex] = useState(initialTabIndex);
    
      useEffect(() => {
        setSelectedIndex(initialTabIndex);
      }, [initialTabIndex]);
    
 
    const [hoveredTab, setHoveredTab] = useState(null);

    const handleMouseEnter = (index) => {
        setHoveredTab(index);
    };

    const handleMouseLeave = () => {
        setHoveredTab(null);
    };

    return (
        <div>
            <div>
                 <Tabs selectedIndex={selectedIndex} onSelect={(index) => setSelectedIndex(index)}>
                <TabList>
                        {['Overview', 'Invoice', 'Packages', 'Questionnaire', 'Template', 'Gallery'].map((tab, index) => (
                            <Tab
                                key={index}
                                onMouseEnter={() => handleMouseEnter(index)}
                                onMouseLeave={handleMouseLeave}
                                style={{
                                    color: hoveredTab === index ? '#080700' : 'initial',
                                    transition: 'color 0.3s ease',
                                }}
                            >
                                {tab}
                            </Tab>
                        ))}
                    </TabList>

                    <TabPanel>
                        <OverviewTab brandingColours={brandingColours} clientData={clientData} businessId={businessId}/>
                    </TabPanel>
                    <TabPanel style={{width: "100%"}}>
                        <InvoiceTab brandingColours={brandingColours} />
                    </TabPanel>
                    <TabPanel>
                        <PackagesTab brandingColours={brandingColours} />
                    </TabPanel>
                    <TabPanel>
                        <QuestionnaireTab brandingColours={brandingColours} />
                    </TabPanel>
                    <TabPanel>
                        <TemplateTab brandingColours={brandingColours} />
                    </TabPanel>
                    <TabPanel>
                        <EventGalleryTab brandingColours={brandingColours} />
                    </TabPanel>
                </Tabs>
            </div>
        </div>
    );
}

export default ClientPortal;